<template>
  <validation-observer ref="formObserver" tag="form" novalidate>
    <div class="form__container row align-items-end">
      <div class="col-md-4 col-12">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            type="text"
            ref="fileName"
            id="document-name"
            name="document-name"
            label="Nombre del Documento"
            placeholder="Ingrese el nombre del documento"
            v-model="model.name"
            :error="errors[0]"
            custom-error-msg="El nombre del documento es requerido."
            maxlength="100"
          />
        </validation-provider>
      </div>
      <div class="col-md-5 col-12">
        <validation-provider
          v-slot="{ errors }"
          :rules="model.id && !isReplacedFile ? '' : 'required'"
        >
          <custom-file-input
            :key="id"
            id="document-file"
            ref="fileUpload"
            label="Archivo"
            v-model="model.file"
            display-style="normal"
            :attachment-id="model.id"
            :name="model.filename"
            :on-download="() => $emit('download')"
            :accept="'.csv'"
            :disabled="false"
            label-position="left"
            :error="errors[0]"
            custom-error-msg="El documento es requerido."
            @after-remove="handleRemoveFile"
          />
        </validation-provider>
      </div>
      <div class="col-md-3 col-12 text-right">
        <action-button
          variant="success"
          i="fas fa-save"
          :text="isEditing ? 'Guardar' : 'Agregar'"
          @click="save"
        />
        <action-button
          v-if="isEditing"
          i="fas fa-times-circle"
          variant="outline-danger m-1 btn-block-xs-only"
          text="Cancelar"
          @click="$emit('cancel')"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import ActionButton from "@/components/common/ActionButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: 'SupportingDocumentForm',
  components: {
    CustomInput,
    ActionButton,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: () => ({
        id: null,
        filename: '',
        name: '',
        file: null,
      })
    },
  },
  data: () => ({
    model: {
      id: null,
      filename: '',
      name: '',
      file: null,
    },
    isReplacedFile: false,
  }),
  computed: {
    isEditing() {
      return this.model.id !== null;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.model)) {
          this.model = { ...newVal };
        }
      }
    },
    model: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal);
      }
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) return;

      this.$refs.formObserver.reset();
      this.$emit('save', this.model);
    },
    handleRemoveFile(id) {
      this.isReplacedFile = this.model.id == id;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.form__container {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.5rem;
}

::v-deep {
  .data-label {
  }

  .input-label {
    font: normal normal normal 14px / 21px Lato !important;
    color: #727272 !important;
  }
}
</style>
